import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, AlertService, UserService } from '@app/_services';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { PropertyService } from '@app/_components/property/property.service';
import * as moment from 'moment';
import { ConstantService } from '@app/_services/constant.service';
import { Reservation, ReservationService } from '@app/_components/reservation';
import { BreezeWaysService } from '@app/_services/breezeways.service';
import { RentalsUnitedService } from '@app/_components/rentals-united/rentals-united.service';
import {ApiResponse} from '@app/_models';
import {environment} from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import {VrboService} from '@app/_services/vrbo.service';
import { ExpenseService, Expense } from '@app/_components/expense';

@Component({
    selector: 'app-property-admin',
    templateUrl: './property-admin.component.html',
    styleUrls: ['./property-admin.component.css'],
    standalone: false
})
export class PropertyAdminComponent implements OnInit {

	@Input() shortTermRentalId: number;

	formLoading = false;
	isSearching = false;
	property: any;
	slPropertyId: any;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private messageService: MessageService,
		private propertyService: PropertyService,
		private constants: ConstantService,
		private breezeWaysService: BreezeWaysService,
		private reservationService: ReservationService,
		private rentalsUnitedService: RentalsUnitedService,
		public userService: UserService,
		private confirmationService: ConfirmationService,
    private http: HttpClient,
    private vrboService: VrboService,
    private expenseService: ExpenseService) { }

	ngOnInit(): void {
		this.findById(this.shortTermRentalId);
	}

	onAutoCreatePropertyFeaturesClick() {
		this.autoCreatePropertyFeatures(this.shortTermRentalId);
	}

	onGenerateLosRatesClick() {
		this.generateLosRates(this.shortTermRentalId);
	}

	onGenerateAllLosRatesClick() {
		this.generateAllLosRates();
	}
	autoCreatePropertyFeatures(shortTermRentalId) {
		try {
			this.formLoading = true;

			this.propertyService.autoCreatePropertyFeatures(shortTermRentalId)
				.subscribe(
					res => {
						console.log('property-find SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success!', detail: res.message, sticky: false });
					},
					err => {
						console.log('property-find FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to autoCreate: ' + err.message, sticky: false });
						this.formLoading = false;
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to autoCreate: ' + error, sticky: false });
			this.formLoading = false;
		}
	}

	generateLosRates(shortTermRentalId) {
		try {
			this.formLoading = true;

			this.propertyService.generateLosRates(shortTermRentalId)
				.subscribe(
					res => {
						console.log('property-find SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success!', detail: res.message, sticky: false });
					},
					err => {
						console.log('property-find FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to autoCreate: ' + err.message, sticky: false });
						this.formLoading = false;
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to autoCreate: ' + error, sticky: true });
			this.formLoading = false;
		}
	}

	generateAllLosRates() {
		try {
			this.formLoading = true;

			this.propertyService.generateAllLosRates()
				.subscribe(
					res => {
						console.log('property-find SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success!', detail: res.message, sticky: false });
					},
					err => {
						console.log('property-find FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to autoCreate: ' + err.message, sticky: false });
						this.formLoading = false;
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to autoCreate: ' + error, sticky: false });
			this.formLoading = false;
		}
	}

  syncBreezewayTask() {
    this.formLoading = true;
    this.expenseService.syncById(this.shortTermRentalId)
      .subscribe(
        res => {
          console.log('syncBreezewayTask: ' + JSON.stringify(res));
          this.formLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Saved', detail: '' + res.message, sticky: false });
        },
        err => {
          console.log('error In login.component is: ' + JSON.stringify(err));
          this.formLoading = false;
          this.messageService.add({ severity: 'error', summary: 'syncBreezewayTask Failed', detail: 'We were unable to save : ' + err, sticky: true });
        },
        () => { });
  }

	saveProperties() {
		this.isSearching = true;
		try {
			this.breezeWaysService.saveProperty(this.shortTermRentalId)
				.subscribe(
					res => {
						this.isSearching = false;
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: saveProperties' });
		}
	}

	saveAllReservationsByProperty() {
		this.isSearching = true;
		try {
			this.breezeWaysService.saveAllReservationsByProperty(this.shortTermRentalId)
				.subscribe(
					res => {
						console.log('saveAllReservationsByProperty: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
						this.isSearching = false;
					},
					err => {
						this.isSearching = false;
						console.log('saveAllReservationsByProperty FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: saveProperties' });
		}
	}

	//this.isSearching = true;
	saveReservation(reservationId: any) {
		try {
			this.breezeWaysService.saveReservation(reservationId)
				.subscribe(
					res => {
						this.isSearching = false;
						console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message, life: 3000 });
					},
					() => { });
		} catch (error) {
			/*this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: saveProperties', life: 3000 });*/
		}
	}
	openWindow(url: string) {
		window.open(url, '_blank');
	}

	saveRuProperty() {
		this.formLoading = true;
		const data = {
			shortTermRentalId: this.shortTermRentalId,
		}
		this.rentalsUnitedService.saveProperty(data)
			.pipe(first())
			.subscribe(
				res => {
					console.log('saveRuProperty: ' + JSON.stringify(res));
					this.formLoading = false;
					this.messageService.add({ severity: 'success', summary: 'Saved', detail: '' + res.message, sticky: false });
				},
				err => {
					console.log('error In login.component is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'saveRuProperty Failed', detail: 'We were unable to save : ' + err, sticky: true });
				},
				() => { });
	}

  saveVrboProperty() {
    this.formLoading = true;
    const data = {
      propertyIds: [Number(this.shortTermRentalId)]
    };
    this.vrboService.saveVrboProperty(data)
      .subscribe(
        res => {
          console.log('saveVrboProperty: ' + JSON.stringify(res));
          this.formLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Saved', detail: '' + res.message, sticky: false });
        },
        err => {
          console.log('error In login.component is: ' + JSON.stringify(err));
          this.formLoading = false;
          this.messageService.add({ severity: 'error', summary: 'saveVrboProperty Failed', detail: 'We were unable to save : ' + err, sticky: true });
        },
        () => { });
  }

  syncLosVrbo() {
    this.formLoading = true;
    this.vrboService.syncLodgingRateLosUpdate(this.shortTermRentalId)
      .subscribe(
        res => {
          console.log('syncLodgingRateLosUpdate: ' + res);
          this.formLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'LOS sync completed successfully', sticky: false });
        },
        err => {
          console.log('error In login.component is: ' + err);
          this.formLoading = false;
          this.messageService.add({ severity: 'error', summary: 'syncLodgingRateLosUpdate Failed', detail: 'We were unable to save : ' + err, sticky: true });
        },
        () => { });
  }

  syncUnitAvailabilityVrbo() {
    this.formLoading = true;
    this.vrboService.syncUnitAvailabilityUpdate(this.shortTermRentalId)
      .subscribe(
        res => {
          console.log('syncUnitAvailabilityUpdate: ' + res);
          this.formLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Unit availability sync completed successfully', sticky: false });
        },
        err => {
          console.log('error In login.component is: ' + err);
          this.formLoading = false;
          this.messageService.add({ severity: 'error', summary: 'syncUnitAvailabilityUpdate Failed', detail: 'We were unable to save : ' + err, sticky: true });
        },
        () => { });
  }

  triggerEndPoint() {
    let endPointAletMessage = 'Re Generate Ledger process started for this property. It will take 20 minutes to finish this process. please do not re-trigger this process for next 20 minutes.\'';
    let name = 'ReGenerate Reservation Ledger';
    let endPoint = 'reservation-ledgers/regenerate-all-ledger/' + this.shortTermRentalId;
    try {
      this.messageService.add({ severity: 'info', summary: 'Alert', detail: endPointAletMessage, sticky: true });
      this.userService.getEndPointResponse(endPoint).subscribe(
        res => {
        },
        err => {
        },
        () => { })
    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: ' + name });
    }
  }

  syncPropertyToYieldMax() {
    try {
		this.formLoading = true;

		this.propertyService.syncPropertyToYieldMax(this.shortTermRentalId)
			.subscribe(
				res => {
					console.log('property-find SUCCESS: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Success!', detail: res.message, sticky: false });
				},
				err => {
					console.log('property-find FAIL: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to sync property: ' + err.message, sticky: false });
					this.formLoading = false;
				},
				() => { this.formLoading = false; });

	} catch (error) {
		this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to sync property: ' + error, sticky: true });
		this.formLoading = false;
	}
  }

	pushRuAvailability() {
		this.formLoading = true;
		const data = {
			shortTermRentalId: this.shortTermRentalId,
		}
		this.rentalsUnitedService.pushAvailability(data)
			.pipe(first())
			.subscribe(
				res => {
					console.log('pushRuAvailability: ' + JSON.stringify(res));
					this.formLoading = false;
					this.messageService.add({ severity: 'success', summary: 'Push Availability', detail: '' + res.message, sticky: false });
				},
				err => {
					console.log('error In login.component is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'pushRuAvailability Failed', detail: 'We were unable to push the availability: ' + err, sticky: true });
				},
				() => { });
	}

	pushRuPrices() {
		this.formLoading = true;
		const data = {
			shortTermRentalId: this.shortTermRentalId,
		}
		// Show message immediately — sync runs in background, do not wait for response
		this.messageService.add({ severity: 'success', summary: 'Sync In Progress', detail: 'RU price sync has started. Please do not click again — prices will be updated in a few minutes.', sticky: true });
		this.formLoading = false;

		this.rentalsUnitedService.pushPrices(data)
			.pipe(first())
			.subscribe(
				res => {
					console.log('pushRuPrices: ' + JSON.stringify(res));
					this.formLoading = false;
					this.messageService.add({ severity: 'success', summary: 'Success: Push Price', detail: res.message, sticky: true });
				},
				err => {
					console.log('Failed: pushRuPrices: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'Failed: Push Price', detail: err?.error?.message || err?.message || 'An unexpected error occurred.', sticky: true });
				},
				() => { });
	}

	// not used - resolver instead
	findById(id: number) {
		try {
			console.log("dodododo");
			this.formLoading = true;
			this.propertyService.findById(id)
				.subscribe(
					res => {
						// console.log('property-find SUCCESS: ' + JSON.stringify(res));
						this.property = res.data.property;
						this.slPropertyId = this.property.slPropertyId;
					},
					err => {
						console.log('property-find FAIL: ' + JSON.stringify(err));
					},
					() => { this.formLoading = false; });

		} catch (error) {
		}
	}

	getEndPointResponse(endPoint: any) {
		this.isSearching = true;
		try {
			this.userService.getEndPointResponse(endPoint)
				.subscribe(
					res => {
						this.isSearching = false;
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Process done successfully ', life: 6000 });
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: saveProperties' });
		}
	}

	getReservationSyncEndPointResponse(endPoint: any) {
		this.isSearching = true;
		try {
			this.userService.getEndPointResponse(endPoint + "/" + this.slPropertyId)
				.subscribe(
					res => {
						this.isSearching = false;
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Process done successfully ', life: 6000 });
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: saveProperties' });
		}
	}

	bustPropertyCache() {
		this.confirmationService.confirm({
			message: 'Bust CDN cache for property #' + this.shortTermRentalId + '? This triggers a full Amplify redeployment.',
			header: 'Confirm Cache Bust',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formLoading = true;
				this.http.post<ApiResponse>(`${environment.apiUrl}/admin/cache-bust`, {
					appId: 'd2cxvbmk3heysp',
					branchName: 'prod',
					paths: ['/vacation-rentals/' + this.shortTermRentalId]
				}).pipe(first()).subscribe(
					(res: any) => {
						this.formLoading = false;
						this.messageService.add({ severity: 'success', summary: 'Cache Bust', detail: 'CDN cache invalidation triggered for property #' + this.shortTermRentalId, life: 5000 });
					},
					(err: any) => {
						this.formLoading = false;
						this.messageService.add({ severity: 'error', summary: 'Cache Bust Failed', detail: err?.error?.message || err.message, life: 5000 });
					}
				);
			}
		});
	}

	bustAllCache() {
		this.confirmationService.confirm({
			message: 'Bust ALL CDN cache? This triggers a full Amplify redeployment and clears all cached pages.',
			header: 'Confirm Full Cache Bust',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formLoading = true;
				this.http.post<ApiResponse>(`${environment.apiUrl}/admin/cache-bust`, {
					appId: 'd2cxvbmk3heysp',
					branchName: 'prod',
					paths: ['/*']
				}).pipe(first()).subscribe(
					(res: any) => {
						this.formLoading = false;
						this.messageService.add({ severity: 'success', summary: 'Full Cache Bust', detail: 'Full CDN cache invalidation triggered.', life: 5000 });
					},
					(err: any) => {
						this.formLoading = false;
						this.messageService.add({ severity: 'error', summary: 'Cache Bust Failed', detail: err?.error?.message || err.message, life: 5000 });
					}
				);
			}
		});
	}
}
